// an overlay popup that appears after a monthly gift is successfully set up

import React from 'react';
import './Monthly_gift_success.css';

import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import GG_confetti from '../../../general_components/GG_confetti/GG_confetti.js';
import { logMonthlySuccessViewed } from '../../../../utils/monthlyGiftAnalytics';

import recurring_gift from '../../../../images/illustrations/recurring_gift_green_bg_100.png';

class Monthly_gift_success extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.open && !prevProps.open) {
            logMonthlySuccessViewed({
                gift_amount: this.props.Gift_amount,
                duration_months: this.props.gift_duration_months,
                next_gift_date: this.props.next_gift_date,
            });
        }
    }

    render() {
        if (!this.props.open) {
            return null;
        }

        const amount = this.props.Gift_amount || '';
        const months = this.props.gift_duration_months || 12;
        const displayAmount = amount && !String(amount).includes('/mo')
            ? `${amount}/mo`
            : amount;

        return (
            <div>
                <GG_confetti />
                <div className='blur_all'></div>
                <div className='overlay monthly_gift_success_popup'>

                    <div className='overlay_icon_and_headline_container'>
                        <i
                            className='material-icons'
                            onClick={this.props.onClose}
                        >
                            close
                        </i>
                        <h2>Thank you!</h2>
                        <div className='overlay_icon_and_headline_container_placeholder'></div>
                    </div>

                    <div className='overlay_text_container'>
                        {this.props.Send_to ? (
                            <p>
                                On behalf of {this.props.Send_to}, thank you for investing in{' '}
                                {this.props.Gift_for}&apos;s future.
                            </p>
                        ) : (
                            <p>
                                Thank you for investing in {this.props.Gift_for}&apos;s future.
                            </p>
                        )}
                        <p>
                            You&apos;ve set up a monthly gift of <span className='bold'>{displayAmount}</span> for{' '}
                            <span className='bold'>{months}</span> month{months === 1 ? '' : 's'}.
                        </p>
                        {this.props.next_gift_date ? (
                            <p>
                                Your next gift will arrive around <span className='bold'>{this.props.next_gift_date}</span>.
                            </p>
                        ) : null}
                        <p>
                            You&apos;ll receive a confirmation by email shortly. Sit back and watch their gift grow, and
                            help lead them toward a brighter future of education and financial security.
                        </p>
                    </div>

                    <img
                        className='overlay_img monthly_gift_success_illus'
                        src={recurring_gift}
                        alt=''
                    />

                    <div className='overlay_buttons_container'>
                        <MasterButton
                            buttonText='Done'
                            handleButtonClick={() => {
                                window.location.href = this.props.doneUrl || '/home';
                            }}
                            notSticky={true}
                            links={true}
                            linkTo={this.props.doneUrl || '/home'}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Monthly_gift_success;
